import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Picker } from 'emoji-mart'
import EmojiIcon from '../UpdoxIcons/EmojiIcon/EmojiIcon';

import classnames from 'classnames';
import 'emoji-mart/css/emoji-mart.css'
import s from './UpdoxEmojiPicker.css';


export default class UpdoxEmojiPicker extends Component {

  static propTypes = {
    onSelect: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    // These refs are so we can tell if a click occurs outside of the emojiPicker so we can close it
    this.emojiPicker = React.createRef();
    this.emojiPickerButton = React.createRef();

    this.state = {
      show: false,
    };
  }

  addEventListeners = () => {
    document.addEventListener('click', this.handleClickOutsideOfEmojiPicker, false);
    document.addEventListener('touchstart', this.handleClickOutsideOfEmojiPicker, false);
    document.addEventListener('keydown', this.handleKeyboardEvents, false);
  };

  removeEventListeners = () => {
    document.removeEventListener('click', this.handleClickOutsideOfEmojiPicker, false);
    document.removeEventListener('touchstart', this.handleClickOutsideOfEmojiPicker, false);
    document.removeEventListener('keydown', this.handleKeyboardEvents, false);
  };

  /**
   * Handles keyboard events.
   * event.which and event.keyCode properties are deprecated and will be removed from the web standard (see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/which).
   * event.code returns a string representation of the keypressed and is the new web standard, but not all browsers have it implemented so which and keycode are available as a fallback.
   * @param event a keyboard event
   */
  handleKeyboardEvents = event => {
    const key = event.code || event.which || event.keyCode;

    switch (key) {
      case 'Escape':
      case 27:
        event.preventDefault();
        event.stopPropagation();
        this.closeEmojiPicker();
        break;
      default:
        break;
    }
  };

  handleClickOutsideOfEmojiPicker = e => {
    if(!this.emojiPickerButton.current.contains(e.target) && !this.emojiPicker.current.contains(e.target)) {
      this.closeEmojiPicker();
    }
  };

  toggleEmojiPicker = (e) => {
    e.preventDefault();
    this.setState({'show': !this.state.show}, () => {
      if (this.state.show) {
        this.addEventListeners();
      } else {
        this.removeEventListeners();
      }
    });
  };

  closeEmojiPicker = () => this.setState({'show': false}, this.removeEventListeners);

  selectEmoji = emoji => {
    this.props.onSelect(emoji.native);
    this.closeEmojiPicker();
  }

  render() {
    const { show } = this.state;
    return (
      <div className={s.container}>
        <button
          className={classnames('icon-link', 'subtle', s.emojiPickerButton)}
          onClick={this.toggleEmojiPicker}
          ref={this.emojiPickerButton}
          type="button"
        >
          <EmojiIcon />
        </button>
        { show &&
        <div
          className={s.emojiPickerContainer}
          ref={this.emojiPicker}
        >
          <Picker
            native
            showPreview={false}
            showSkinTones={false}
            onSelect={this.selectEmoji}
            style={{
              border: 'none',
              width: '100%',
              }}
            autoFocus
          />
        </div>
        }
      </div>
    );
  }
}
